// P.R. Net Com - Mock Data

export const companyInfo = {
  name: "P.R. NET COM",
  tagline: "A Complete IT Solution",
  established: 2014,
  certification: "ISO 9001:2008",
  proprietor: "Rabi Ranjan Sarkar",
  experience: "11+ Years",
  address: "155, Dumdum Road, Ghoshpara, Kolkata - 700074",
  phones: ["+91 9674876102", "+91 9830220126"],
  email: "prnetcom.in@gmail.com",
  gst: "19BIPPS1006Q1ZK",
  gemId: "0L11230008748735"
};

export const services = [
  {
    id: 1,
    title: "Hardware Solutions",
    description: "Computer and related accessories selling with comprehensive support for all your hardware needs.",
    icon: "Monitor"
  },
  {
    id: 2,
    title: "Server & Maintenance",
    description: "Expert maintenance of all kinds of Servers, Printers, Switches, and PCs with 24/7 support.",
    icon: "Server"
  },
  {
    id: 3,
    title: "Network Installation",
    description: "All types of Networking installation & maintenance including structured cabling solutions.",
    icon: "Network"
  },
  {
    id: 4,
    title: "Software Solutions",
    description: "All types of software supply & installation tailored to your business requirements.",
    icon: "Code"
  },
  {
    id: 5,
    title: "IT Facility Management",
    description: "Complete IT facility management service ensuring smooth operations round the clock.",
    icon: "Building"
  },
  {
    id: 6,
    title: "Cisco L2 Switch",
    description: "Supply and installation of Cisco Make L2 Switch for enterprise-grade networking.",
    icon: "Cpu"
  },
  {
    id: 7,
    title: "Wi-Fi Solutions",
    description: "Supply and installation of Wi-Fi Modem and Network System for seamless connectivity.",
    icon: "Wifi"
  },
  {
    id: 8,
    title: "Annual Maintenance",
    description: "Comprehensive AMC for Hardware & Network ensuring uninterrupted business operations.",
    icon: "Wrench"
  },
  {
    id: 9,
    title: "Online UPS Solutions",
    description: "Sales and services of Online UPS systems for uninterrupted power supply to critical IT infrastructure.",
    icon: "Zap"
  },
  {
    id: 10,
    title: "Battery Supply",
    description: "SMF and Tubular Battery supply for UPS systems ensuring reliable backup power solutions.",
    icon: "Battery"
  }
];

export const clients = [
  { id: 1, name: "UCO Bank", type: "Banking" },
  { id: 2, name: "State Bank of India", type: "Banking" },
  { id: 3, name: "West Bengal State Co-operative Bank", type: "Banking" },
  { id: 4, name: "West Bengal Gramin Bank", type: "Banking" },
  { id: 5, name: "South Dumdum Municipality", type: "Government" },
  { id: 6, name: "Apollo LogiSolutions", type: "Logistics" },
  { id: 7, name: "Uniken Pvt. Ltd.", type: "Technology" },
  { id: 8, name: "Baishnadevi Processing", type: "Industry" }
];

export const testimonials = [
  {
    id: 1,
    name: "Mr. Shantanu Ghosh",
    position: "Deputy General Manager, UCO Bank",
    content: "P.R. Net Com has been instrumental in maintaining our banking IT infrastructure across multiple branches. Their 24/7 support and quick response time have ensured zero downtime for our critical operations. A truly reliable partner for any financial institution.",
    rating: 5
  },
  {
    id: 2,
    name: "Mr. Debjit Ghosh",
    position: "Assistant General Manager, West Bengal State Co-Operative Bank",
    content: "Exceptional service quality and technical expertise. The team at P.R. Net Com understands the unique requirements of cooperative banking systems. Their proactive maintenance approach has significantly improved our network efficiency.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Soumo Roy",
    position: "Chief Manager, West Bengal Gramin Bank",
    content: "Outstanding professionalism and dedication. P.R. Net Com's comprehensive IT solutions have streamlined our rural banking operations. Their expertise in networking and hardware support is unmatched in the industry.",
    rating: 5
  },
  {
    id: 4,
    name: "Madhab Choudhury",
    position: "AGM - IT Department, State Bank of India",
    content: "Working with P.R. Net Com has been a seamless experience. Their team demonstrates deep technical knowledge and always delivers solutions that exceed our expectations. The quality of their service is truly commendable.",
    rating: 5
  },
  {
    id: 5,
    name: "Mr. Ratneshwar Prasad",
    position: "Sr. Manager, UCO Bank Balasore Zonal",
    content: "P.R. Net Com's commitment to excellence is evident in every interaction. Their swift troubleshooting and preventive maintenance have kept our zonal operations running flawlessly. Highly recommended for banking IT needs.",
    rating: 5
  },
  {
    id: 6,
    name: "Mr. Kamalesh Kumar",
    position: "Sr. Manager, UCO Bank Salt Lake Zonal",
    content: "Reliable, efficient, and always available. P.R. Net Com has been our go-to IT partner for network installations and AMC services. Their technical team is highly skilled and responsive to our requirements.",
    rating: 5
  }
];

export const stats = [
  { value: "11+", label: "Years Experience" },
  { value: "500+", label: "Projects Completed" },
  { value: "50+", label: "Happy Clients" },
  { value: "24/7", label: "Support Available" }
];

export const operationalStates = [
  "West Bengal",
  "Karnataka",
  "Maharashtra",
  "Delhi",
  "Tamil Nadu",
  "Gujarat",
  "Rajasthan",
  "Uttar Pradesh",
  "Madhya Pradesh",
  "Bihar",
  "Odisha",
  "Andhra Pradesh",
  "Telangana",
  "Kerala",
  "Punjab"
];

export const certifications = [
  {
    id: 1,
    title: "ISO 9001:2008",
    description: "Quality Management System Certified",
    year: "2014"
  }
];

export const partners = [
  {
    id: 1,
    name: "Switching AVO Electro Power Limited",
    shortName: "Switching AVO Electro Power Limited",
    image: "https://static.prod-images.emergentagent.com/jobs/f1f8d16f-a0ec-4e33-be94-a81c013770fb/images/b67d525076195406c59e7bf560f0500e70cd3174d2d2e6254c0fc3b1bbd7c196.png",
    category: "Online UPS"
  },
  {
    id: 2,
    name: "AMARON QUANTA",
    shortName: "AMARON QUANTA",
    image: "https://static.prod-images.emergentagent.com/jobs/f1f8d16f-a0ec-4e33-be94-a81c013770fb/images/c4d102cd2aa4e3ef3c8d788c4d8a43208cbdc262705cf0ff548671280ff6cbaf.png",
    category: "UPS Battery"
  },
  {
    id: 3,
    name: "Starlite",
    shortName: "Starlite",
    image: "https://static.prod-images.emergentagent.com/jobs/f1f8d16f-a0ec-4e33-be94-a81c013770fb/images/31cf9da90c9137cf1ee0e19c69bf76e3a02313ea919613b0b1d893ed956a671c.png",
    category: "RAM"
  },
  {
    id: 4,
    name: "Arin Computer",
    shortName: "Arin Computer",
    image: "https://static.prod-images.emergentagent.com/jobs/f1f8d16f-a0ec-4e33-be94-a81c013770fb/images/b173c133d30c33922f8c7e4bb2a64a3537b14afc9d55ffc06c19ad5479508db4.png",
    category: "Server"
  }
];
